import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  color: var(--gray_intermediary);
  font-weight: 500;
  font-size: 1.5rem;
  padding: 1rem 0;
  gap: 3rem;

  > div {
    display: flex;
    flex-direction: column;
    text-align: center;
    width: max-content;
  }

  > span {
    font-weight: 700;
    flex: 2;
  }
`;
